/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { View, type ViewStyle } from 'react-native';
import { operationalFilterStyles as styles } from './operationalFilters.styles';

type Props = {
  children: React.ReactNode;
  bodyStyle?: ViewStyle;
};

export function OperationalFiltersCard({ children, bodyStyle }: Props) {
  return (
    <View style={styles.panel}>
      <View style={styles.cardWrap}>
        <View style={styles.cardAccent} pointerEvents="none" accessibilityElementsHidden />
        <View style={[styles.cardBody, bodyStyle]}>{children}</View>
      </View>
    </View>
  );
}
